<template>
  <div>
    <div class="wrapper wrapper-content animated fadeInUp">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-content">
              <div>
                <project-header v-if="project" :project="project"></project-header>
              </div>
              <div class="row m-t-sm">
                <project-content v-if="project" :project="project"></project-content>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectHeader from './Header/Header.vue'
import ProjectContent from './Content/Content.vue'
import { useProjectStore } from '../../../../../stores/ProjectStore'
import { useTaskStore } from '../../../../../stores/TaskStore'

export default {
  setup () {
    const store = useProjectStore()
    const taskStore = useTaskStore()
    return { store, taskStore }
  },
  data () {
    return {
      project: null
    }
  },
  components: {
    projectHeader: ProjectHeader,
    projectContent: ProjectContent
  },
  mounted () {
    this.store.loadProject(this.$route.params.id).then(r => {
      this.project = this.store.project
      document.title = this.project.name + ' :: Project :: PBN360 by Aphex Media'
      this.taskStore.updateFilters('project', this.project.id)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Single/Project.vue